angular
  .module('fca-used')
  .component('root', {
    templateUrl: 'app/root/root.html',
    controller: rootController,
    controllerAs: 'root'
  });

rootController.$inject = ['$window', 'asyncTasks', 'CONFIG'];
function rootController($window, asyncTasks, CONFIG) {
  var self = this;
  self.asyncTasks = asyncTasks;
  self.$onInit = function () {
    self.class = [
      'market-' + CONFIG.market.id,
      'language-' + CONFIG.language.id,
      'brand-' + CONFIG.brand.id,
      'protocol-' + $window.location.protocol.replace(/:/g, '').toLowerCase()
    ];
  };
}
